import { render, staticRenderFns } from "./noticyPage.vue?vue&type=template&id=7da9cfb2&scoped=true"
import script from "./noticyPage.vue?vue&type=script&lang=js"
export * from "./noticyPage.vue?vue&type=script&lang=js"
import style0 from "./noticyPage.vue?vue&type=style&index=0&id=7da9cfb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da9cfb2",
  null
  
)

export default component.exports